/**
 * Support-ticket context capture (#1311, CS-INTAKE follow-up).
 * Builds the auto-attached diagnostics blob sent with support-ticket
 * submissions: the route the user was on, the deployed app build (from
 * /api/version — same source UpdateBanner polls), and the browser user agent.
 *
 * Best-effort by design: a failed /api/version fetch degrades to an empty
 * app_version and must never block or delay a ticket submission beyond the
 * one cached fetch.
 */

export interface SupportTicketContext {
  route: string
  app_version: string
  user_agent: string
}

// '' is a valid cached value (version fetch failed); null means "not yet tried".
let cachedAppVersion: string | null = null

async function fetchAppVersion(): Promise<string> {
  try {
    const r = await fetch('/api/version')
    if (!r.ok) return ''
    const data = await r.json() as { version?: string }
    return data.version ?? ''
  } catch {
    return ''
  }
}

export async function buildSupportContext(): Promise<SupportTicketContext> {
  if (cachedAppVersion === null) {
    cachedAppVersion = await fetchAppVersion()
  }
  return {
    route: window.location.pathname,
    app_version: cachedAppVersion,
    user_agent: navigator.userAgent,
  }
}
